import script from "./CheckpointListView.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckpointListView.vue?vue&type=script&setup=true&lang=js"

import "./CheckpointListView.vue?vue&type=style&index=0&id=825590e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-825590e8"]])

export default __exports__